import getQuote from "./translations/fr/get-quote"
import routes from "./translations/fr/routes"
import newMortgage from "./translations/fr/new-mortgage"
import renewal from "./translations/fr/renewal"
import rates from "./translations/fr/rates"
import landing from "./translations/fr/landing"
import about from "./translations/fr/about"
import footer from "./translations/fr/footer"
import terms from "./translations/fr/terms"
import privacy from "./translations/fr/privacy"
import hero from "./translations/fr/hero"
import faq from "./translations/fr/faq"

export default {
  ...routes,
  ...landing,
  ...getQuote,
  ...newMortgage,
  ...renewal,
  ...rates,
  ...about,
  ...footer,
  ...terms,
  ...privacy,
  ...hero,
  nav: {
    how_it_works: "Notre Approche",
    about: "À propos de Nesto",
    jobs: "Emplois",
    number: "(613) 791-1798",
    numberFormatted: "6138589213",
    faq: "QFD",
    faqLink: "/qfd",
    getStarted: "COMPARER LES TAUX",
    terms_link: "Conditions d'utilisation",
    privacy_policy: "Politique de confidentialité",
    otherLanguage: "English"
  },
  ...faq,
  calculator: {
    title: "Estimer combien d'argent vous pouvez obtenir.",
    province: {
      title: "De quelle province provenez-vous?",
      placeholder: "Selectionner"
    },
    town: {
      title: "Selectionner une ville",
      placeholder: "Selectionner"
    },
    ageOfYoungestHomeOwner: {
      title: "Quel est l'âge du plus jeune propriétaire?",
      placeholder: "Selectionner"
    },
    estimatedValueOfYourHome: {
      title: "Quelle est la valeur estimée de votre maison?",
      placeholder: "Minimum $250,000"
    },
    cta: "CONTINUE"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/fr.js